/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2026-03-25 21:12:17
 * @LastEditors: 'yanghongye'
 * @LastEditTime: 2026-04-29 13:43:22
 * @Description: file content
 */
/**
 * 默认特性开关表 —— 所有允许被国家覆写的开关，必须在此声明
 *
 * ═══════════════════════════════════════════════════════════
 * 命名规则：Module-Page-Feature（连字符分隔，每段大驼峰）
 * ═══════════════════════════════════════════════════════════
 *
 *  层级         含义                           示例
 * ─────────────────────────────────────────────────────────
 *  Module       所属功能模块                   Login / Home / Address / Store / Print / Package / COD / Compliance
 *  Page         所属页面或子模块               ForgotPassword / OrderTrend / PrintLabel
 *  Feature      具体特性动作                   Show / Enable / Hide
 *
 * 多模块/多页面共用的开关，Module 使用 "Common"：
 *   例：'Common-Export-Enable'
 *
 * 所有开关默认 false，国家层按需开启为 true
 */
const standardFeatureFlags = {
  // ─── Login 登录模块 ────────────────────────────────────
  /** 登录页 - 找回密码按钮 */
  'Login-ForgotPassword-Show': false,
  /** 登录页面需要用户条款和隐私政策 */
  'Login-NeedTermsAndPrivacy': false,
  /** 登录页面需要使用账户登录 */
  'Login-UseAccountLogin': false,
  /** 登录页面需要设备ID */
  'Login-NeedDeviceId': false,
  /** 找回密码是否使用手机号方式 */
  'Login-ForgotPassword-UsePhone': false,

  // ─── Home 首页模块 ─────────────────────────────────────
  /** 首页 - 订单趋势图（VN、IDN 有） */
  'Home-OrderTrend-Show': false,

  /** 首页 - 待处理面板（MY 有） */
  'Home-PendingBoard-Show': false,

  /** 首页 - 快递信息/包裹统计模块（VN、IDN 有） */
  'Home-OrderParcelStatistics-Show': false,

  // ─── Address 地址模块 ──────────────────────────────────
  /** 地址 - 越南地址级联选择器 */
  'Address-CascadeSelector-Show': false,

  /** 地址 - 马来地址邮编选择器 */
  'Address-PostcodeSelector-Show': false,

  // ─── Store 站点设置模块 ────────────────────────────────
  /** 站点设置 - 面单 76*150mm（IDN、VN） */
  'Store-PrintLabel76x150-Enable': false,

  /** 站点设置 - 面单 100*110mm（MY） */
  'Store-PrintLabel100x110-Enable': false,

  /** 站点设置 - 打印LOGO开关显示 */
  'Store-ShowLogoSwitch-Enable': false,

  // ─── Print 打印模块 ────────────────────────────────────
  /** 打印对话框 - CCM 面单模板 */
  'Print-CcmTemplate-Enable': false,

  // ─── Package 包裹管理模块 ──────────────────────────────
  /** 包裹管理 - 退件功能（IDN 有） */
  'Package-Return-Enable': false,

  // ─── COD 代收货款模块 ──────────────────────────────────
  /** COD - 统计页面（VN、IDN 有） */
  'COD-Statistics-Show': false,

  /** COD - 异常支付审核（VN、IDN 有） */
  'COD-AbnormalPayment-Show': false,

  // ─── Compliance 合规模块 ───────────────────────────────
  /** 合规 - Cookie 授权弹窗（DE） */
  'Compliance-CookieConsent-Enable': false,

  /** 合规 - 数据脱敏（DE） */
  'Compliance-PrivacyMask-Enable': false,

  /** 合规 - 数据处理同意书（DE） */
  'Compliance-DataConsent-Enable': false,

  /** 派件列表- 支持whatsapp的批量提醒(IDN有) */
  'DispatchList-Batch-Notice': false,
  /** 地址是否需要邮箱 */
  'Address-NeedEmail-Enable': false,
  /** 头部是否需要下载中心 */
  'Header-NeedDownloadCenter-Enable': false,
  /** 头部是否需要快件跟踪 */
  'Header-NeedTracking-Enable': false,
  /** 面单打印字体包 */
  'Print-FontPackage-Enable': false,
  /** 菜单 - 个性化菜单功能（VN 有） */
  'Menu-Personalized-Enable': false,
  /** 是否需要手机号脱敏组件 */
  'DecryptIdCard-Enable': false,
  /** 头部是否显示学习中心入口 */
  'Header-LearningCenter-Show': false,
}

export type StandardFeatureFlags = typeof standardFeatureFlags
export default standardFeatureFlags
